module.exports = __webpack_public_path__ + "static/media/my-team-share.0d106de0.svg";